import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function Address(props) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M22.8991 21.8184H1.0907C0.488159 21.8184 0 22.3067 0 22.9101C0 23.5124 0.488159 24.0008 1.0907 24.0008H22.8986C23.5011 24.0008 23.9893 23.5124 23.9893 22.9101C23.9887 22.3067 23.5006 21.8184 22.8991 21.8184Z"
        fill="#D69A00"
      />
      <Path
        d="M2.45398 18.9792C1.85144 18.9792 1.36328 19.4676 1.36328 20.0704C1.36328 20.6732 1.85144 21.1621 2.45398 21.1621H21.5361C22.1387 21.1621 22.6268 20.6732 22.6268 20.0704C22.6268 19.4676 22.1387 18.9792 21.5361 18.9792H21.2639V9.16049H21.5361C21.8379 9.16049 22.081 8.9163 22.081 8.6154C22.081 8.3145 21.8369 8.07031 21.5361 8.07031H2.45398C2.15271 8.07031 1.90914 8.3145 1.90914 8.6154C1.90914 8.9163 2.15322 9.16049 2.45398 9.16049H2.72666V18.9787H2.45398V18.9792ZM19.0826 9.16049V18.9787H15.8115V9.16049H19.0826ZM13.6301 9.16049V18.9787H10.359V9.16049H13.6301ZM4.90703 9.16049H8.17811V18.9787H4.90703V9.16049Z"
        fill="#FFB800"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.8986 7.09048H1.09072C0.576519 7.09048 0.132273 6.73135 0.0245308 6.22866C-0.0837221 5.72598 0.174144 5.21614 0.643411 5.00464L11.5484 0.0957863C11.8333 -0.0319288 12.1586 -0.0319288 12.443 0.0957863L23.2632 4.96684C23.6916 5.11397 24 5.5201 24 5.99929C24 6.6021 23.5124 7.09048 22.9093 7.09048H22.8986ZM12.478 2.5467H12.896L13 2H11.118L11 2.66758H11.544C11.7653 2.67125 11.9087 2.78388 11.974 3.00549H11.104L11 3.54945H11.986C11.9233 3.82234 11.7687 3.95879 11.522 3.95879H11.048L11.05 4.44231L12.018 6H12.68V5.96154L11.806 4.53846C12.046 4.47436 12.23 4.36172 12.358 4.20055C12.486 4.03938 12.5653 3.82234 12.596 3.54945H12.894L13 3.00549H12.598C12.5793 2.8315 12.5393 2.67857 12.478 2.5467Z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default Address;
